import { toCamelCaseProperties } from "@/utils/fn";

export default class WebshopMainCategory {
  constructor(args) {
    args = toCamelCaseProperties(args) || {};

    this.id = args.id || 0;
    this.webshopCategoryId = args.webshopCategoryId || 0;
    this.title = args.title || "";
    this.urlSafeTitle = args.urlSafeTitle || "";
    this.icon = args.icon || "category";
    this.description = args.description || "";
    this.tags = args.tags || [];
    this.textSearch = args.textSearch || "";
    this.children = args.children
      ? args.children.map((child) => new WebshopMainCategory(child))
      : [];
    this.image = args.image ? this.categoryImage(args.image?.ImageCrops) : {};
  }

  categoryImage(imagesList) {
    if (imagesList?.length) {
		let teaser = imagesList.find(img => img.Alias == "FacebookOpenGraph")
		if(teaser){
			return teaser
		} else {
			return imagesList[0]
		}
    } else {
      return {};
    }
  }
}
